import * as CubeTree from '../cubeTree/index';
import { __clear__, __delete__, __hasCube__ } from './db';

function clear(): void {
    __clear__();
}

function del(cubeId: CubeId): void {
    if (!__hasCube__(cubeId)) {
        return;
    }

    let allChildren: Array<CubeId> = CubeTree.findAllChildrenContainSelf(cubeId);

    allChildren.forEach((delCube: CubeId): void => {
        __delete__(delCube);
    });
}

function delGroup(cubeIds: Array<CubeId>): void {
    cubeIds.forEach((cubeId: CubeId): void => {
        del(cubeId);
    });
}

export {
    clear,
    del,
    delGroup
};
